import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

/**
 * Formats a date as "January 19th 2026" format
 * @param {Date|string|number|dayjs.Dayjs} date - The date to format
 * @returns {string} Formatted date string
 */
export function formatDisplayDate(date) {
    if (!date) return '';
    return dayjs(date).format('MMMM Do YYYY');
}

/**
 * Formats a date with time as "January 19th 2026, 10:30 AM" format
 * @param {Date|string|number|dayjs.Dayjs} date - The date to format
 * @returns {string} Formatted date and time string
 */
export function formatDisplayDateTime(date) {
    if (!date) return '';
    return dayjs(date).format('MMMM Do YYYY, h:mm A');
}

/**
 * Formats a short date as "January 19th" (without year)
 * @param {Date|string|number|dayjs.Dayjs} date - The date to format
 * @returns {string} Formatted date string without year
 */
export function formatDisplayDateShort(date) {
    if (!date) return '';
    return dayjs(date).format('MMMM Do');
}

/**
 * How a quote's or section's validity reads to the customer, as a label and a value:
 * "Valid:" "October 27th 2026 to November 30th 2026", or just one end when only one is set.
 * @param {{validFrom?: string|number, validUntil?: string|number}} o
 * @param {(date: any) => string} [format]
 * @returns {{title: string, value: string|null}}
 */
export function validityField(o, format = formatDisplayDate) {
    const { validFrom, validUntil } = o || {};
    if (validFrom && validUntil) return { title: 'Valid:', value: `${format(validFrom)} to ${format(validUntil)}` };
    if (validUntil) return { title: 'Valid until:', value: format(validUntil) };
    if (validFrom) return { title: 'Valid from:', value: format(validFrom) };
    return { title: 'Valid until:', value: null };
}

/**
 * The same validity as one sentence, for the email text: "This offer is valid from … until …".
 */
export function validitySentence(o, format = formatDisplayDate) {
    const { validFrom, validUntil } = o || {};
    if (validFrom && validUntil) return `This offer is valid from ${format(validFrom)} until ${format(validUntil)}`;
    if (validUntil) return `This offer is valid until ${format(validUntil)}`;
    if (validFrom) return `This offer is valid from ${format(validFrom)}`;
    return '';
}

export default { formatDisplayDate, formatDisplayDateTime, formatDisplayDateShort, validityField, validitySentence };
